function initLPTestimonialSpotlight(id = '') {
  const elemLPTestimonialSpotlight = document.getElementById(id);

  if (!elemLPTestimonialSpotlight) {
    return;
  }

  const swiper = new Swiper(elemLPTestimonialSpotlight.querySelector('.swiper'), {
    slidesPerView: 1,
    speed: 600,
  });

  const prevButtons = elemLPTestimonialSpotlight.querySelectorAll('[data-testimonial-prev]');
  const nextButtons = elemLPTestimonialSpotlight.querySelectorAll('[data-testimonial-next]');

  prevButtons.forEach((button) => button.addEventListener('click', () => swiper.slidePrev()));
  nextButtons.forEach((button) => button.addEventListener('click', () => swiper.slideNext()));
}
